import AuthLayout from "../../components/layout/AuthLayout";
import RegisterBox from "../../components/registerBox/RegisterBox";
import { useState } from "react";
import {
  OTPPage,
  SendIdentityCodePage,
} from "../../router/path-route/PathRoute";
import { RequestOTP } from "../../auth/Index";
import { useNavigate } from "react-router-dom";

export default function PhoneNumber() {
  const [bgButton, setBgButton] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [err, setErr] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInput = (value) => {
    const next = value.slice(0, 11);
    setInputValue(next);
    if (next === "") {
      setErr(true);
      setBgButton(false);
      return;
    }
    setBgButton(next.length === 11);
    if (next.length !== 11) {
      setErr(true);
    }
  };

  const handleGetCode = () => {
    if (inputValue.length !== 11 || loading) return;
    setLoading(true);
    const data = {
      mobile: inputValue,
      identityCode: localStorage.getItem("identityCode"),
      isLogin: false,
      nationality: "IR",
    };
    RequestOTP(data)
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem("mobile", inputValue);
          localStorage.setItem("message", res.data.message);
          setErr(true);
          navigate(OTPPage);
        }
      })
      .catch((err) => {
        if (err.response?.status === 405) {
          localStorage.setItem("mobile", inputValue);
          navigate(OTPPage);
        } else {
          setErrorMessage(err.response?.data?.message || "");
          setErr(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <AuthLayout previousPage={SendIdentityCodePage}>
      <RegisterBox
        bgButton={bgButton && !loading}
        setInputValue={handleInput}
        inputValue={inputValue}
        placeholder="شماره همراه راننده"
        btnTitle="دریافت کد"
        title="شماره همراه خود را وارد نمایید."
        errorMessage={errorMessage}
        err={err}
        handleClick={handleGetCode}
        maxLength={11}
      />
    </AuthLayout>
  );
}
